const DOTS_PER_INCH = 96;
const INCH_TO_METER = 0.0254;

/**
 * Converts millimeters to points.
 *
 * @param mmValue - value in [mm]
 * @return value in points
 */
export function convertMmToPoints (mmValue: number) {
  const valueInMeters = mmValue * 0.001;
  const valueInInch = valueInMeters / INCH_TO_METER;
  const valueInPixels = valueInInch * DOTS_PER_INCH;
  const pixelToPointFactor = 72 / 96;
  return valueInPixels * pixelToPointFactor;
}
